// Tolerant list-unwrapper for admin pages.
//
// Several gateway endpoints return `{ data: [...], pagination: {...} }`
// while a handful still return a bare `[...]`. The admin pages were
// written before that was consistent, and several do `res.data ?? []`
// expecting an array — which silently becomes a paginated object at
// runtime and blows up the first `.map` / `.filter` / `.reduce` they hit.
// This helper collapses both shapes down to a safe `T[]`.
export function unwrapList<T = unknown>(body: unknown): T[] {
  if (Array.isArray(body)) return body as T[]
  if (body && typeof body === 'object' && 'data' in body) {
    const inner = (body as { data: unknown }).data
    if (Array.isArray(inner)) return inner as T[]
  }
  return []
}
